import AdminErrorState from "../Components/AdminErrorState";

export default function AdminNotFound() {
  return (
    <AdminErrorState
      status="notfound"
      title="Sayfa bulunamadı"
      description="Talep ettiğiniz yönetim sayfası mevcut değil veya bu alana erişim izniniz yok."
      actionLabel="Ops ana ekranına dön"
      onAction={() => {
        window.location.href = "/admin/ops?tab=dashboard";
      }}
      helpHref="/admin/platform?tab=help"
    />
  );
}
